import React from 'react';
import { Button } from './common/Button';
import { Mail } from 'lucide-react';
export function WaitlistSection() {
  return <section className="py-32 bg-[#1A1A1A] relative overflow-hidden" data-id="element-896">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-897">
        <div className="absolute -top-24 -left-24 w-64 h-64 bg-[#FFFC00] rounded-full opacity-10 blur-3xl" data-id="element-898"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full opacity-5 blur-3xl" data-id="element-899"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-900">
        <h2 className="text-5xl sm:text-7xl font-black mb-8 text-white uppercase tracking-tight" data-id="element-901">
          Ready to get <span className="text-[#FFFC00]" data-id="element-902">rewarded?</span>
        </h2>
        <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto font-medium" data-id="element-903">
          Join hundreds of shoppers earning free perks at their favorite local
          spots.
          <br data-id="element-904" />
          <br data-id="element-905" />
          Got more questions? Slide into our inbox.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-6" data-id="element-906">
          <Button variant="primary" size="lg" href="https://kraya.live/" className="text-xl py-5 px-12 shadow-[4px_4px_0px_0px_rgba(255,255,255,0.2)] hover:shadow-none hover:translate-y-1 transition-all" data-id="element-907">
            Download the app
          </Button>
        </div>

        {/* Playful Contact Section */}
        <div className="mt-20 flex justify-center" data-id="element-908">
          <a href="mailto:hello@kraya.live" className="group relative inline-flex items-center gap-3 bg-[#FF90E8] border-4 border-[#1A1A1A] rounded-2xl py-4 px-8 shadow-[6px_6px_0px_0px_rgba(255,252,0,1)] transform rotate-2 hover:rotate-0 hover:translate-y-1 hover:shadow-[2px_2px_0px_0px_rgba(255,252,0,1)] transition-all duration-200" data-id="element-909">
            {/* Decorative tape piece */}
            <div className="absolute -top-3 -left-4 w-12 h-6 bg-white/50 backdrop-blur-sm border-2 border-[#1A1A1A] transform -rotate-12" data-id="element-910"></div>

            <Mail className="w-8 h-8 text-[#1A1A1A] group-hover:animate-wiggle" data-id="element-911" />
            <div className="text-left" data-id="element-912">
              <p className="text-[#1A1A1A] font-black uppercase text-sm tracking-widest leading-none mb-1" data-id="element-913">
                Got questions?
              </p>
              <p className="text-[#1A1A1A] font-bold text-xl leading-none" data-id="element-914">
                Slide into our inbox
              </p>
            </div>
          </a>
        </div>
      </div>
    </section>;
}